module.exports = __webpack_public_path__ + "img/header-engagementRingsCollectionRings.b7fa407.webp";